import { Modal, Form, Input, message, Typography, Collapse, Button, Select, Alert, Upload } from 'antd';
import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { apiClient } from '../../api_actions';

const { Text } = Typography;
const { TextArea } = Input;

const EmailModal = ({ open, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [emailChains, setEmailChains] = useState()
  const [targetEmails, setTargetEmails] = useState([])
  const [emailFormats, setEmailFormats] = useState([])
  const [deployments, setDeployments] = useState([])
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [allUsers, setAllUsers] = useState([])

  const loadAllUsers = async () => {
    try{
      var users = []
      var url = 'read/users'
      const result = await apiClient.post(url)
      result.data.map((field) => {
        users.push({"label":field["email"],"value":field["user_id"]})
      })
      setAllUsers(users)
    } catch (error) {
      console.log("Failed to load users", error)
    }
  }

  const loadTargetEmails = async (email_chain_id, project_id) => {
    try {
        var taget_emails = []
        var url = `read/users?email_chain_id=${email_chain_id}&project_id=${project_id}`
        const result = await apiClient.post(url);
        result.data.map((field) => {
            taget_emails.push({"label":field["email"],"value":field["user_id"]})
        })

        
        setTargetEmails(taget_emails);
        form.setFieldsValue({ users: taget_emails });
    } catch (error) {
        console.error('Failed to load emails', error);
    }
  }

  const loadEmailFormats = async () => {
    try {
      var email_formats = []
      const result = await apiClient.post("read/email_formats");
      result.data.map((field) => {
          email_formats.push({"label":field["name"],"value":field["data"]})
      })
      setEmailFormats(email_formats)
    } catch (error) {
      console.error('Failed to load Email Formats', error)
    }
  }

  const loadDeployments = async () => {
    try {
      var deployments = []
      const result = await apiClient.post("read/deployments");
      result.data.map((field) => {
          deployments.push({"label":`${field["hardware_info"]["tag"]} ${field["project"]["project_name"]} ${field["location"]["name"]}`,"value":field["project"]["project_id"]})
      })
      setDeployments(deployments)
    } catch (error) {
      console.error('Failed to load Deployments', error)
    }
  }

  const loadEmailChain = async () => {
    try {
        var email_chains = []
        const result = await apiClient.post("read/email_chains");
        result.data.map((field) => {
            email_chains.push({"label":field["name"],"value":field["email_chain_id"]})
        })
        setEmailChains(email_chains);
    } catch (error) {
        console.error('Failed to load schedules', error);
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);  // contains full data URL
          reader.onerror = reject;
          reader.readAsDataURL(file);                    // triggers async read
    });

    const payload = {
        email_chain_id:values.email_chains,
        input_field:values.inputField,
        user_ids:values.users.map((user) => user.value)
    }

    if (values?.upload?.[0].originFileObj) {
      const file = values.upload[0].originFileObj;
      const base64Data = await toBase64(file); // must await
      payload["upload"] = {
              filename: file.name,
              type: file.type, // e.g., application/vnd.openxmlformats-officedocument.wordprocessingml.document
              data: base64Data
          }
    }
    apiClient.post('create/emailer',payload)
    onClose()
    setLoading(false)
  };

  useEffect(() => {
    if (!open) return;

    const fetchData = async () => {
      setLoading(true);
      try {
          await Promise.all([
              loadEmailChain(),
              loadEmailFormats(),
              loadDeployments(),
              loadAllUsers()
          ]);
      } catch (error) {
          console.error("Failed to load data:", error);
      } finally {
          setLoading(false);
      }
    };

    fetchData();
  }, [open]); 
    

const EmailAlert = ({ emails = [] }) => {
  const description = (
    <Collapse
      ghost
      size="small"
      items={[
        {
          key: '1',
          label: `Show ${emails.length} recipient(s)`,
          children: (
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {emails.map((email) => (
                <li key={email.label}>
                  <Text copyable>{email.label}</Text>
                </li>
              ))}
            </ul>
          ),
        },
      ]}
    />
  );

  return (
    <Alert
      message="This will email all users in this chain."
      description={description}
      type="warning"
      showIcon
    />
  );
};

  return (
    <Modal
      title="Mass Emailer"
      open={open}
      onCancel={onClose}
      onOk={() => setConfirmModalVisible(true)} // Trigger form submission
      confirmLoading={loading}
      afterClose={() => form.resetFields()} // Reset on close
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >

    <Form.Item
      name="email_chains"
      label="Email Chain"
      rules={[{ required: true, message: 'Please select the email chain' }]}
    >
      <Select
        mode="select"
        placeholder="Email Chains"
        options={emailChains}
        onChange={(value) => {
          loadTargetEmails(value, form.getFieldValue('deployment') ?? -1)
        }}
      />
    </Form.Item>

    <Form.Item
      name="email_formats"
      label="Email Formats"
      rules={[{ required: true, message: 'Please select the email format' }]}
    >
      <Select
        mode="select"
        placeholder="Email Formats"
        options={emailFormats}
        onChange={(value) => {
          form.setFieldsValue({ inputField: value });
        }}

      />
    </Form.Item>

    <Form.Item
      name="deployment"
      label="Deployment"
      rules={[{ required: false, message: 'Please select the deployment' }]}
    >
      <Select
        mode="select"
        placeholder="Deployments"
        options={deployments}
        onChange={(value) => {
          loadTargetEmails(form.getFieldValue('email_chains')  ?? -1, value)
        }}
      />
    </Form.Item>

    <Form.Item
      name="users"
      label="Users"
      rules={[{ required: false, message: 'Please select the users' }]}
    >
      <Select
        showSearch={true}
        mode={"multiple"}
        allowClear={true}
        filterOption={(input, option) =>
          option.label?.toLowerCase().includes(input.toLowerCase())
        }
        options={allUsers}
      />
                
                
      </Form.Item>

    <Form.Item
      name="inputField"
      label="Your Input"
      rules={[
        { required: true, message: 'Please enter some text' },
        { min: 3, message: 'Must be at least 3 characters' }
      ]}
    >
      <TextArea rows={4} placeholder="Enter text here" />
    </Form.Item>
      {/* </Form> */}
    <Form.Item
      name="upload"
      valuePropName="fileList"
      getValueFromEvent={(e) => {
          if (Array.isArray(e)) return e;
          return e?.fileList;
        }}
    >
      <Upload beforeUpload={() => false}>
        <Button icon={<UploadOutlined />}>File Upload</Button>
      </Upload>
    </Form.Item>
    </Form>

      <Modal
        title="Confirm Email Chain"
        open={confirmModalVisible}
        onOk={() => {
          setConfirmModalVisible(false);
          form.submit()
        }}
        onCancel={() => {
          setConfirmModalVisible(false);
          //setModalData({ action: null, value: null, record: null });
        }}
      >

      <EmailAlert emails={targetEmails}/>
      </Modal>
    </Modal>
  );
};

export default EmailModal;
